import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#763A3A",
      d: "M9.177 6.627a.625.625 0 0 0-.917.844l.063.068 2.847 2.67-2.847 2.668a.625.625 0 0 0-.087.812l.058.072c.215.229.561.26.811.087l.072-.059 3.334-3.125a.625.625 0 0 0 .065-.84l-.065-.072-3.334-3.125Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "jiantou"}) } }